export const COMMON_PATIENT_INCLUDES = [
  'user',
  'patient_status',
  'organization',
  'rx_form.location',
  'customer_request.printing_request.location',
  'customer_request.printing_request'
];
